import { Auth } from "components";
import SignupView from "./SignupView";

export const SignupContainer = () => {
  return (
    <Auth>
      <SignupView />
    </Auth>
  );
};
